import React from 'react';
import { withRouter } from 'react-router-dom';
import Tabs from '../../../common/components/Tabs';
import { TechnicalControl, Tournaments  } from '../../../admin/containers';
//import { withNamespaces } from 'react-i18next';


const Dashboard = (props) => {
//  const { t } = props;

  const panes = [
    {
      title: 'Technical Control',
      path: '/referee/tc',
      contents: <TechnicalControl/>
    },
    {
      title: 'Schedules',
      path: '/referee/schedules',
      contents: <Tournaments/>
    }
  ];

  return  <Tabs panes={panes}/>;
};

export default withRouter(Dashboard);

//export default withNamespaces('referee')(withRouter(Dashboard));




// WEBPACK FOOTER //
// ./src/private/referee/components/Dashboard/index.js